const levels = {
    ERROR: 0x01,
    WARN: 0x02,
    INFO: 0x04,
    TRACE: 0x08,
};

const masks = {
    NONE: 0x00,
    ERROR: 0x01,
    WARN: 0x03,
    INFO: 0x07,
    TRACE: 0x15,
    ALL: 0xff,
};

const stdout = (level, message, context = {}) => {
    const now = new Date();
    const time = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;

    // eslint-disable-next-line no-console
    console.log(JSON.stringify({
        namespace,
        level,
        time,
        message,
        context,
    }));
};

let mask = masks.ERROR;
let namespace = 'catalog-frontend-service';

const setLevel = (m, n) => {
    namespace = n;
    mask = masks[m];
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    setLevel,
    // eslint-disable-next-line no-bitwise
    trace: (message, context) => !!(mask & levels.TRACE) && stdout('TRACE', message, context),
    // eslint-disable-next-line no-bitwise
    info: (message, context) => !!(mask & levels.INFO) && stdout('INFO', message, context),
    // eslint-disable-next-line no-bitwise
    warn: (message, context) => !!(mask & levels.WARN) && stdout('WARN', message, context),
    // eslint-disable-next-line no-bitwise
    error: (message, context) => !!(mask & levels.ERROR) && stdout('ERROR', message, context),
};
